import { render, staticRenderFns } from "./ClienteSetup.vue?vue&type=template&id=aafb752c"
import script from "./ClienteSetup.vue?vue&type=script&lang=js"
export * from "./ClienteSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports